import {
  FetchUsersFilters,
  FetchUsersSort,
  FetchUsersPage,
  FetchUsersLimit
} from '../../usersTypes';

import {
  useInfiniteIndexQuery,
  InfiniteIndexQueryBaseNodeType
} from '../../../common/reactQuery/hooks/useInfiniteIndexQuery';

import {
  INITIAL_USERS_FILTERS,
  INITIAL_USERS_LIMIT,
  INITIAL_USERS_SORT
} from '../../usersConstants';

interface UsersOptions {
  cacheKey: string;
  query: string;
  initialFilters?: FetchUsersFilters;
  initialSort?: FetchUsersSort;
  initialPage?: FetchUsersPage;
  initialLimit?: FetchUsersLimit;
  options?: {
    cacheTime?: number;
    staleTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
  };
}

const scope = 'users';

function useUsers<ItemType extends InfiniteIndexQueryBaseNodeType>({
  cacheKey,
  query,
  initialFilters = INITIAL_USERS_FILTERS,
  initialSort = INITIAL_USERS_SORT,
  initialLimit = INITIAL_USERS_LIMIT,
  options = {}
}: UsersOptions) {
  const {
    data,
    items,
    itemsError,
    itemsTotalCount,
    isFetched,
    isLoading,
    isFetchingNextPage,
    isPlaceholderData,
    currentPage,
    currentLimit,
    currentFilters,
    currentSort,
    hasNextPage,
    updateItemCache,
    loadMoreItems,
    filterItems,
    changeItemsFilters,
    clearItemsFilters,
    sortItems,
    limitItems
  } = useInfiniteIndexQuery<ItemType>({
    cacheKey,
    initialFilters,
    initialLimit,
    initialSort,
    options,
    query,
    scope
  });

  return {
    usersData: data,
    users: items,
    usersError: itemsError,
    usersTotalCount: itemsTotalCount,
    usersFetched: isFetched,
    usersLoading: isLoading,
    usersFetchingNextPage: isFetchingNextPage,
    usersIsPlaceholderData: isPlaceholderData,
    usersFilters: currentFilters,
    usersSort: currentSort,
    usersPage: currentPage,
    usersLimit: currentLimit,
    hasNextUsersPage: hasNextPage,
    updateUserCache: updateItemCache,
    loadMoreUsers: loadMoreItems,
    filterUsers: filterItems,
    changeUsersFilters: changeItemsFilters,
    clearUsersFilters: clearItemsFilters,
    sortUsers: sortItems,
    limitUsers: limitItems
  };
}

export default useUsers;
